<template>
  <div class="main-page">
    <Menu :title="lawTitle" :home="true">
      <template slot="right-link">
        <div class="servicePoint"></div>
      </template>
    </Menu>
    <div class="container-flex">
      <template v-if="lawSort.length">
        <div class="lawlist">
          <div class="lawsort noscroll">
            <template v-for="(item, index) in lawSort">
              <div class="item" @click="switchtab(index, item)" :class="{ active: index == current }"
                :key="'key-law-sort-' + index" v-if="!item.parentId">
                {{ item.name }}
              </div>
            </template>
          </div>
          <div class="list-con noscroll">
            <template v-if="childRe && childRe.length">
              <div class="item" v-for="(item, index) in childRe" :key="'key-l' + index">
                <div @click.stop="switchKind(item)">
                  <img src="/img/ui/law/lawbook_w.png">
                  <p class="txtone">
                    {{ item.name }}
                  </p>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="notice">
                <h2>该分类下暂无数据~请点击左侧分类查看其他数据</h2>
              </div>
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="reclist">
          <h2>暂无相关数据~</h2>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import Menu from '@/components/Menu'
import * as lawApi from '../../datas/js/law'
import { listToTree } from '@/plugins'

export default {
  components: {
    Menu
  },
  data () {
    return {
      lawSort: [],
      current: 0,
      type: '',
      reclist: [],
      childRe: [],
      aindex: '',
      lawTitle: '全国法律法规库'
    }
  },
  mounted () {
    this.getProList()
    // this.getLawSort()
    this.type = this.$route.query.type || null
  },
  methods: {
    getProList () {
      lawApi.getBindPro(1).then(res => {
        if (res.response.success && res.data) {
          this.lawSort = listToTree(res.data) || []
          this.switchtab(0, this.lawSort[0], true)
        } else {
          console.log('[ got an error response ]', res.response.msg)
        }
      }).catch(error => {
        console.log('[ catch an error ]', error)
      })
    },
    switchtab (index, item = {}, defaultFitst = false) {
      this.current = index || 0
      if (defaultFitst) {
        this.childRe = item.children || []
        return
      }
      if (item.children && item.children.length) {
        this.childRe = item.children
      } else {
        this.$router.push({
          path: `/LawSearch?title=搜索结果&professionalId=${item.id}`
        })
      }
    },
    switchKind (item = {}) {
      if (item.children && item.children.length) {
        this.childRe = item.children
      } else {
        this.$router.push({
          path: `/LawSearch?title=搜索结果&professionalId=${item.id}`
        })
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.container-flex
  padding 0.3rem 0.6rem 0.5rem 0.6rem
.lawlist
  height 100%
  overflow hidden
  background-color rgba(255, 255, 255, 0.2)
  border-radius 0.3rem
  border solid 1px rgba(255, 255, 255, 0.2)
  display flex
  .lawsort
    width 3.5rem
    height 100%
    overflow-y scroll
    background-color rgba(255, 255, 255, 0.2)
    .item
      height 0.9rem
      padding-left 0.7rem
      color #fff
      box-sizing border-box
      border-bottom 2px solid rgba(255, 255, 255, 0.2)
      line-height 0.9rem
      &:last-child
        border 0
      &.active
        background #fc9d0b
  .list-con
    flex 1
    height 100%
    overflow-y scroll
    clear both
    .item
      width 20%
      float left
      text-align center
      color #fff
      img
        width 0.99rem
        height 1.24rem
        object-fit cover
        margin 0.7rem 0 0.29rem 0
      p
        display block
        padding 0 0.1rem 0.3rem 0.1rem
        color #fff
        font-size 0.3rem
    .notice
      font-size 0.36rem
      line-height 1.5
      color #fff
      width 100%
      height 100%
      display flex
      align-items center
      justify-content center
.reclist
  width 12rem
  height 5rem
  margin 0.8rem auto
  text-align center
  padding 0.2rem 0
  font-size 0.48rem
</style>
